<template>
    <section
        id="lesson-form"
        class="max-width-600-tablet-desktop page-section--offset-bottom-middle"
    >
        <el-form
            ref="formRef"
            :model="form"
            label-width="100px"
            :rules="rules"
            @submit.prevent="saveSubmit"
        >
            <el-form-item
                label="Title"
                prop="title"
                :error="errors.get('title')"
            >
                <el-input
                    v-model="form.title"
                    suffix-icon="edit-pen"
                    @change="errors.clear('title')"
                />
            </el-form-item>
            <el-form-item
                label="Video Url"
                prop="url"
                :error="errors.get('url')"
            >
                <el-input
                    v-model="form.url"
                    suffix-icon="edit-pen"
                    @change="errors.clear('url')"
                />
            </el-form-item>
            <el-form-item
                label="Transcript"
                prop="transcript"
                :error="errors.get('transcript')"
            >
                <el-input
                    v-model="form.transcript"
                    type="textarea"
                    @change="errors.clear('transcript')"
                />
            </el-form-item>
            <el-form-item
                label="Embedded"
                prop="embedded"
                :error="errors.get('embedded')"
            >
                <el-input
                    v-model="form.embedded"
                    type="textarea"
                    @change="errors.clear('embedded')"
                />
            </el-form-item>
            <el-form-item
                label="Tips"
                prop="tips"
                :error="errors.get('tips')"
            >
                <el-input
                    v-model="form.tips"
                    type="textarea"
                    @change="errors.clear('tips')"
                />
            </el-form-item>
        </el-form>
        <div>
            <el-button
                @click="cancel"
            >
                Cancel
            </el-button>
            <el-button
                :loading="formLoading"
                type="success"
                @click="saveSubmit"
            >
                Save
            </el-button>
        </div>
    </section>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue'
import { ElMessage } from 'element-plus'
import {Errors} from '~/includes/Errors'
import lessonApi from '../../lessonApi'

const emit = defineEmits()

const props = defineProps({
    initialForm: {
        type: Object,
        default: {}
    },
})

const errors = new Errors()
const formLoading = ref(false)
const form = ref({name: ''})
const rules = {
    title: [
        { required: true, message: 'Title is required' },
    ],
    transcript: [
        { required: true, message: 'Transcript is required' },
    ],
    url: [
        { required: true, message: 'Url is required' },
    ],
    embedded: [
        { required: true, message: 'Embedded is required' },
    ],
    tips: [
        { required: true, message: 'Tips is required' },
    ],
}

onMounted(() => form.value = Object.assign({}, props.initialForm))

watch(
    () => props.initialForm,
    val => form.value = Object.assign({}, val),
    { deep: true }
)

const formRef = ref()

function saveSubmit() {
    formRef.value.validate((valid) => {
        if (valid) {
            formLoading.value = true
            errors.clear()

            const action = form.value._id ? lessonApi.update : lessonApi.add
            action(form.value).then((response) => {
                ElMessage.success( 'Saved successfully')
                emit('saved', response.data.data._id)
            }).catch(error => {
                if (error.response.data.errors) errors.record(error.response.data.errors)
            }).finally(() => formLoading.value = false)
        }
    })
}

function cancel() {
    clearForm()
    emit('cancel0')
}

function clearForm() {
    errors.clear()
    if (formRef.value) formRef.value.resetFields()
}
</script>
